import styled from "styled-components";
import {Person, PromptResult, StyledBaseProps} from "@betrue/shared/interfaces";
import Card from "@mui/material/Card";
import {Avatar, CardActionArea, CardActions, CardContent, Chip, Fade, Modal} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import CardMedia from "@mui/material/CardMedia";
import {fileUrl} from "@betrue/front/services";
import DescriptionIcon from '@mui/icons-material/Description';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';

interface LogoCardViewProps extends StyledBaseProps {
  logoImage: PromptResult
  principal: Person
}

const classes = {
  gridList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)"
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundcolor: "red"
    }
  },
  img: {
    outline: "none"
  }
};

export const LogoCardView = styled((props: LogoCardViewProps) => {

  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("false");
  const handleClose = () => {
    setOpen(false);
  };

  const handleImage = (value) => {
    setImage(value);
    setOpen(true);
  };
  return (<div  key={props.logoImage.id}><Modal
      style={classes.modal}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      disablePortal={true}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={open} timeout={500} style={classes.img}>
        <img
          src={image}
          alt="asd"
          style={{maxHeight: "90%", maxWidth: "90%"}}
        />
      </Fade>
    </Modal>
      <Card>
        <CardActionArea
          onClick={() => handleImage(fileUrl(props.logoImage.file))}>
          <CardMedia
            sx={{height: 512}}
            image={fileUrl(props.logoImage.file)}
          >
          </CardMedia>

        </CardActionArea>
        <CardActions style={{overflowX: 'scroll'}}>
          {props.principal ? (<Chip icon={<ModelTrainingIcon/>} label={props.logoImage.model}/>) : ''}
          <Chip icon={<DescriptionIcon/>} label={props.logoImage.prompt}/>
          <Chip icon={<AutoFixHighIcon/>} label={props.logoImage.promptTemplateLabel}/>
          {props.logoImage.inputWeight && props.logoImage.inputImage?.id ? (
            <Chip label={props.logoImage.inputWeight}/>) : ''}
          {props.logoImage.inputImage ? (
            <Avatar alt="input" onClick={()=> handleImage(fileUrl(props.logoImage.inputImage))} src={fileUrl(props.logoImage.inputImage)} />) : ''}


        </CardActions>
      </Card>
    </div>
  )
})
  `
    & {
    }
  `
